import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import RarityBadge from '@/components/RarityBadge';
import Button from '@/components/Button';
import checkedIcon from '@/assets/checked.svg';
import { formatCurrency } from '@/utils/formatUtils';
import { getProductThumbnailUrl } from '@/utils/imageUtils';

const SuccessSection = ({
  listingData,
  cardType,
  onCancel,
  onCancelListing,
  onAdjust,
  onListAnother,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  // Check if this is a first-time listing with reward
  const isFirstTimeListing = listingData?.benefitReward?.issueReward;
  const rewardAmount = listingData?.benefitReward?.rewardAmount;

  const getConditionText = (condition) => {
    if (!condition) return '';
    return t(`sell.product_info.conditions.${condition.toLowerCase()}`);
  };

  const handleAdjust = () => {
    navigate('/me/listings');
  };

  const handleCancelListing = () => {
    if (onCancelListing) {
      onCancelListing(listingData.id);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div className="w-[204px] aspect-[0.723] mb-8">
        <div data-state="default&pressed" className="w-full h-full px-1.5 pt-1.5 pb-3 bg-white rounded-md outline outline-1 outline-offset-[-1px] outline-[#dddddd] inline-flex flex-col justify-start items-start gap-2 overflow-hidden">
          <div className="self-stretch flex-1 relative bg-white rounded overflow-hidden">
            <img 
              src={getProductThumbnailUrl(listingData.product?.images?.[0]?.url)} 
              alt={listingData.product.localizedName}
              className="w-48 h-[180px] left-0 top-0 absolute object-contain mix-blend-darken"
            />
            <div className="bottom-[4px] absolute w-full px-1 flex">
              <div className='px-1.5 py-[3px] bg-[#EEEEEEBF] backdrop-blur-[16px] rounded font-["Noto_Sans_JP"] font-normal text-xs leading-[150%] text-[#111111] line-clamp-1'>{listingData.product.brand.localizedName}</div>
            </div>
          </div>
          
          <div className="self-stretch px-1.5 flex-col justify-end items-start gap-2 flex">
            <div className="self-stretch text-[#111111] text-sm line-clamp-1">
              {listingData.product.localizedRawName || listingData.product.localizedName}
              {cardType !== 'CARD_BOX' && listingData.product.rarityInfo?.sub?.name ? `(${listingData.product.rarityInfo.sub.name})` : ''}
            </div>
            <div className="flex flex-wrap items-center gap-1">
              {cardType !== 'CARD_BOX' && listingData.product.rarityInfo?.main && (
                <RarityBadge rarity={listingData.product.rarityInfo.main} />
              )}
              {(listingData.product?.set?.code || (listingData.product?.rawCode && cardType !== 'CARD_BOX')) && (
                <div className="h-[18px] px-1 bg-[#f4f4f4] rounded-[3px] outline outline-[0.50px] outline-offset-[-0.50px] outline-[#dddddd] flex justify-start items-center gap-2.5">
                  <div className="justify-start text-[#111111] text-sm font-normal leading-[14px]">
                    {cardType === 'CARD_BOX' ? listingData.product?.set?.code : (listingData.product?.set?.code && listingData.product?.rawCode ? `${listingData.product.set.code} ${listingData.product.rawCode}` : listingData.product?.set?.code || listingData.product?.rawCode)}
                  </div>
                </div>
              )}
            </div>
            <div className="self-stretch flex items-center gap-2 justify-between">
              <div className="text-[#111111] text-lg font-medium">
                {formatCurrency(listingData.price)}
              </div>
              <div className="text-right justify-center text-[#aaaaaa] text-sm font-normal leading-[21px]">
                {cardType === 'PSA_SINGLE_CARD' && listingData.psa.replace('_', ' ')}
                {cardType === 'NON_PSA_SINGLE_CARD' && getConditionText(listingData.condition)}
                {cardType === 'CARD_BOX' && `x${listingData.bundledQuantity}`}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-2xl font-bold mb-2 flex items-center">
        <img src={checkedIcon} alt="checked" className="w-6 h-6 mr-2" />
        {isFirstTimeListing ? t('sell.success.first_time_title') : t('sell.success.title')}
      </div>
      
      {isFirstTimeListing ? (
        <div className="text-base mb-6" style={{ fontFamily: 'Noto Sans JP', color: '#FF5601', fontWeight: 700 }}>
          {t('sell.success.first_time_description', { amount: rewardAmount })}
        </div>
      ) : (
        <div className="text-[#969696] text-base mb-6">
          {t('sell.success.description')}
        </div>
      )}

      <div className="flex gap-4">
        {/* <Button variant="default" onClick={handleCancelListing}>
          {t('sell.success.cancel')}
        </Button> */}
        <Button variant="default" onClick={handleAdjust}>
          {t('sell.success.active_listings')}
        </Button>
        <Button variant="primary" onClick={onListAnother}>
          {t('sell.success.list_another')}
        </Button>
      </div>
    </div>
  );
};

export default SuccessSection; 
